import { Controller } from "@hotwired/stimulus"

// A marker states where a value came from, so it has to stop claiming that the
// moment the user changes the value. This is the reason the marker is an icon
// per field rather than a header banner: a banner cannot become partly true —
// which is also why the summary banner is wired to disappear here, the moment
// the last marker does, rather than lagging behind as a stale count.
//
// Bulk invalidation (a fresh registry pick, or the search term diverging from
// the company that was picked) is handled separately by
// legal_entity_controller#populateFields / #clearDependentFields, which hide
// every marker at once because every value they describe is being replaced
// together. This controller only ever handles ONE field at a time: the user
// editing a single already-filled input or radio by hand.
export default class extends Controller {
  static targets = ["marker", "summaryBanner"]

  clear(event) {
    // Plain fields are keyed by their own DOM id (see shared/registry/_search
    // and _address.html.erb). A radio GROUP has one id per option
    // (party_vat_payer_type_standard, _foreign, ...), so whichever option the
    // user actually picks carries an explicit data-provenance-field pointing
    // back at the one marker for the whole group — see
    // workspaces/partials/_vat_payer_type.html.erb.
    const key = event.target.dataset.provenanceField || event.target.id
    const marker = this.markerTargets.find((m) => m.dataset.field === key)
    if (!marker) return

    marker.classList.add("d-none")

    // The banner summarizes what these markers, together, show. Once none of
    // them are left true, the summary isn't stale — it's actively wrong, so it
    // goes away with the last marker instead of lagging behind it.
    if (this.hasSummaryBannerTarget && this.markerTargets.every((m) => m.classList.contains("d-none"))) {
      this.summaryBannerTarget.classList.add("d-none")
    }
  }
}
